import { CreateElement, VNode, VNodeData } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

type IconFamilies = 'material-icons';
type FontSizes = 'inherit' | 'default' | 'small' | 'large';
type Color =
  | 'default'
  | 'inherit'
  | 'error'
  | 'primary'
  | 'secondary'
  | 'success';

@Component
export default class ClIcon extends Vue {
  @Prop({
    type: String as () => IconFamilies,
    default: 'material-icons',
    validator: (x: IconFamilies) => ['material-icons'].includes(x)
  })
  private family!: IconFamilies;

  @Prop({
    type: String as () => FontSizes,
    default: 'default',
    validator: (x: FontSizes) =>
      ['inherit', 'default', 'small', 'large'].includes(x)
  })
  private fontSize!: FontSizes;

  @Prop({ type: String, default: 'span' })
  private component!: string;

  @Prop({
    type: String as () => Color,
    default: 'inherit',
    validator: x =>
      [
        'default',
        'inherit',
        'error',
        'primary',
        'secondary',
        'success'
      ].includes(x)
  })
  private color!: string;

  public render(h: CreateElement): VNode {
    const data: VNodeData = {
      class: {
        'cl-icon': true,
        [this.family]: true,
        [`cl-icon--color-${this.color}`]: true,
        [`cl-icon--font-size--${this.fontSize}`]: true
      },
      on: this.$listeners
    };
    return h(this.component, data, this.$slots.default);
  }
}
